// extracted by mini-css-extract-plugin
export default {"nav":"navBar_nav__viD5S","buttonsWrap":"navBar_buttonsWrap__lGBZn","goUp":"navBar_goUp__meljH"};